import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonGridComponent } from './common-grid.component';
import { CommonGridFooterComponent } from './common-grid-footer/common-grid-footer.component';
import { GridUtilsModule } from '@frontend-site/grid/grid-utils';
import { AgGridModule } from '@ag-grid-community/angular';
import { TranslateModule } from '@ngx-translate/core';
import { PButtonModule } from '@panaya/ui/p-button';
import { PTooltipModule } from '@panaya/ui/p-tooltip';
import { PipeModule } from '@panaya/ui/pipes';
import { PActionButtonModule } from '@panaya/ui/p-action-button';
import { PFieldModule } from '@frontend-site/ui/components';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { NgLetModule } from 'ng-let';
import { MatMenuModule } from '@angular/material/menu';

@NgModule({
    declarations: [CommonGridComponent, CommonGridFooterComponent],
    imports: [
        PipeModule,
        CommonModule,
        MatMenuModule,
        PFieldModule,
        ScrollingModule,
        GridUtilsModule,
        AgGridModule,
        TranslateModule,
        PButtonModule,
        PTooltipModule,
        PActionButtonModule,
        NgLetModule
    ],
    exports: [CommonGridComponent, CommonGridFooterComponent]
})
export class CommonGridModule {}
